import React, { Component } from "react";
import { Spin, Modal, Row, Col, Button, Descriptions, Pagination } from "antd";
import { history } from "../../../helpers";
import StaffView from "./StaffView";

import { getClinicList } from "../../../services";

export default class StaffContainer extends Component {
  render() {
    const { details } = this.props;
    return <StaffView details={details} />;
  }
}
